import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@jsverse/transloco';
import { TranslocoLocaleModule } from '@jsverse/transloco-locale';
import { AccountMiniCardComponent } from './components/account-mini-card/account-mini-card.component';
import { BadgeComponent } from './components/badge/badge.component';
import { CardContentComponent } from './components/card-content/card-content.component';
import { CardImageComponent } from './components/card-image/card-image.component';
import { CardComponent } from './components/card/card.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { ContentLoaderComponent } from './components/content-loader/content-loader.component';
import { CurrencyComponent } from './components/currency/currency.component';
import { CurrentAccountBalanceComponent } from './components/current-account-balance/current-account-balance.component';
import { ErrorContainerComponent } from './components/error-container/error-container.component';
import { FormControlComponent } from './components/form-control/form-control.component';
import { LikeCounterComponent } from './components/like-counter/like-counter.component';
import { MenuPopoverComponent } from './components/menu-popover/menu-popover.component';
import { NavbarItemComponent } from './components/navbar-item/navbar-item.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { PasswordComponent } from './components/password/password.component';
import { PreLoaderComponent } from './components/pre-loader/pre-loader.component';
import { QrCodeComponent } from './components/qrcode/qrcode.component';
import { SelectComponent } from './components/select/select.component';
import { CguLoyaltyEnComponent } from './containers/cgu-loyalty/cgu-loyalty-en/cgu-loyalty-en.component';
import { CguLoyaltyFrComponent } from './containers/cgu-loyalty/cgu-loyalty-fr/cgu-loyalty-fr.component';
import { CguLoyaltyComponent } from './containers/cgu-loyalty/cgu-loyalty.component';
import { CguEnComponent } from './containers/cgu/cgu-en/cgu-en.component';
import { CguFrComponent } from './containers/cgu/cgu-fr/cgu-fr.component';
import { CguComponent } from './containers/cgu/cgu.component';
import { FaqFilterPipe } from './containers/faq/faq-filter.pipe';
import { FaqComponent } from './containers/faq/faq.component';
import { HeaderComponent } from './containers/header/header.component';
import { LogoComponent } from './containers/logo/logo.component';
import { ReloadButtonComponent } from './containers/reload-button/reload-button.component';
import { ScorpCgvEnComponent } from './containers/scorp-cgv/scorp-cgv-en/scorp-cgv-en.component';
import { ScorpCgvFrComponent } from './containers/scorp-cgv/scorp-cgv-fr/scorp-cgv-fr.component';
import { ScorpCgvComponent } from './containers/scorp-cgv/scorp-cgv.component';
import { VersionsComponent } from './containers/versions/versions.component';
import { ClickStopPropagationDirective } from './directives/click-stop-propagation.directive';
import { ElRefDirective } from './directives/el-ref.directive';
import { FocusDirective } from './directives/focus.directive';
import { NgLetDirective } from './directives/ng-let.directive';
import { TriggerOnClicksDirective } from './directives/trigger-on-clicks.directive';
import { IsIconFromAssetsPipe } from './pipes/is-icon-from-assets.pipe';
import { IsNotNullorUndefinedPipe } from './pipes/is-not-null-or-undefined.pipe';
import { IsOrderCancelablePipe } from './pipes/is-order-cancelable.pipe';
import { IsOrderValidatedPipe } from './pipes/is-order-validated.pipe';
import { MailToPipe } from './pipes/mail-to.pipe';
import { TimeLeftPipe } from './pipes/time-left.pipe';
import { TrustHtmlPipe } from './pipes/trust-html.pipe';

const forms = [SelectComponent, CheckboxComponent];

const cguComponents = [CguComponent, CguEnComponent, CguFrComponent];
const cguLoyaltyComponents = [CguLoyaltyComponent, CguLoyaltyEnComponent, CguLoyaltyFrComponent];
const scorpCgvComponents = [ScorpCgvComponent, ScorpCgvFrComponent, ScorpCgvEnComponent];

const exporteds = [
  AccountMiniCardComponent,
  NavbarComponent,
  NavbarItemComponent,
  HeaderComponent,
  MenuPopoverComponent,
  ContentLoaderComponent,
  ErrorContainerComponent,
  PreLoaderComponent,
  CardContentComponent,
  CurrentAccountBalanceComponent,
  CardComponent,
  CardImageComponent,
  FormControlComponent,
  NgLetDirective,
  FaqComponent,
  FaqFilterPipe,
  FocusDirective,
  ClickStopPropagationDirective,
  TriggerOnClicksDirective,
  ElRefDirective,
  VersionsComponent,
  PasswordComponent,
  LikeCounterComponent,
  BadgeComponent,
  LogoComponent,
  ...cguComponents,
  ...cguLoyaltyComponents,
  ...scorpCgvComponents,
  ...forms,
  TrustHtmlPipe,
  TimeLeftPipe,
  IsOrderCancelablePipe,
  IsIconFromAssetsPipe,
  IsOrderValidatedPipe,
  IsNotNullorUndefinedPipe,
  MailToPipe,
  CurrencyComponent,
  QrCodeComponent,
  ReloadButtonComponent,
];
@NgModule({
  declarations: [...exporteds],
  imports: [CommonModule, IonicModule, TranslocoModule, TranslocoLocaleModule, RouterModule, IonicModule, ReactiveFormsModule],
  exports: [...exporteds, TranslocoModule, TranslocoLocaleModule, RouterModule, ReactiveFormsModule],
})
export class SharedModule {}
